import {
  TCustomGetServerSideProps,
  getG11nAndTranslationsFromServer,
  initializeApollo,
} from '@crehana/next';

import { CountryCode } from '@crehana/ts-types';

import { getFeatureFlag } from '@crehana/utils';

import { getSEOFooterData } from '@/shared/components/SEOFooter/data';

import { IAppProps } from '../types';
import locales from '../i18n';
import { HOMEPAGE_PAGE_KEY } from '../constants';
import getSeoHomepage from '../utils/getSeoHomepage';
import getCompaniesLogos from '../utils/getCompaniesLogos';

const getServerSideProps: TCustomGetServerSideProps<IAppProps> = async ({
  req,
  query,
}) => {
  const countryCode = (query.country as CountryCode) || null;

  const SEOFooterData = getSEOFooterData(countryCode);

  const apolloClient = initializeApollo({
    headers: req.headers,
    pageKey: HOMEPAGE_PAGE_KEY,
  });

  const featureFlagLogos = await getFeatureFlag(
    apolloClient,
    'enable_new_home_page',
  );

  const companiesLogosCountry =
    countryCode === null || countryCode === '*' ? '' : countryCode;

  const [g11nData, seo, companiesLogos] = await Promise.all([
    getG11nAndTranslationsFromServer({
      headers: req.headers,
      pageKey: HOMEPAGE_PAGE_KEY,
      defaultTranslations: locales,
    }),
    getSeoHomepage(apolloClient, countryCode),
    getCompaniesLogos(
      apolloClient,
      featureFlagLogos ? companiesLogosCountry : 'pe',
    ),
  ]);

  return {
    props: {
      ...g11nData,
      companiesLogos,
      featureFlags: {
        featureFlagLogos,
      },
      SEOData: {
        footer: SEOFooterData,
        metaTitle: seo.metaTitle,
        metaDescription: seo.metaDescription,
      },
    },
  };
};

export default getServerSideProps;
